import "./style.less";
export default function homeController($scope, articles) {
    $scope.articles = articles;
    // Scroll.to("main-content-focus", siteService.headerHeight + 15);
}
